/**
 * Safe logger that only outputs detailed error info in development.
 * In production, logs a generic message without leaking GraphQL
 * schema details, stack traces, or internal error structures.
 */

const isDev = import.meta.env.MODE === 'development';

export function logError(context: string, ...args: unknown[]): void {
  if (isDev) {
    console.error(`[${context}]`, ...args);
  } else {
    // Production: log only the context label — no error details
    console.error(`[${context}] An error occurred`);
  }
}

export function logWarn(context: string, ...args: unknown[]): void {
  if (isDev) {
    console.warn(`[${context}]`, ...args);
  }
}

/** Development-only diagnostic logging. Silent in production builds. */
export function logDebug(context: string, ...args: unknown[]): void {
  if (isDev) {
    console.log(`[${context}]`, ...args);
  }
}
